'use client';
import { lazy, Suspense, type ComponentProps } from 'react';
export type * from "/tmp/build-370/node_modules/@eliadmin/core/src/pages/(profile)/my-curriculums/page.tsx";
type Props = NonNullable<ComponentProps<typeof import("/tmp/build-370/node_modules/@eliadmin/core/src/pages/(profile)/my-curriculums/page.tsx").default>>;
const Deferred = lazy(() => import("@eliadmin/route-original/1929f834a9a7"));
function DeferredRoute(props: Props) { return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }
export default DeferredRoute;

